import { ReactElement, useEffect, useState } from 'react'
import {
  SectionTitle,
  TableWrapper,
  TableHeader,
  TableFooter,
  Modal,
  FlexWrapper,
  Loader,
  PageWrapper,
  Button
} from '../../../../components'
import strings from '../../../../locale/en'
import { DisplayAdminCount, FormBackWrapper, TableRow } from '../subcomponents'
import UserFilterSection from '../UserFilterSection'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import UserAction from '../UserAction'
import { Admin } from '../../../../redux/coachingCenter/types'
import {
  getBranches,
  getBatches,
  getAdminList,
  getInstitutes,
  selectAdmin,
  resetInstitute
} from '../../../../redux/coachingCenter/actions'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../const/routes'
import AdminType from '../../../../const/admin'
import {
  getInstituteDropdown,
  getBranchDropDown,
  getBatchDropdown,
  getSelectedInstitute,
  getSelectedBranch,
  getSelectedBatch
} from '../helpers'
import { deleteUserDetail } from '../../../../redux/userDetail/actions'
import { initialState } from '../Teacher/const'
import { DropdownListProps } from '../../../../components/EditableDropdown/typings'

const SuperAdmin = (): ReactElement => {
  const {
    institutes = [],
    branches = [],
    batches = [],
    admin,
    isLoading,
    selectedCoachingCentreId = '',
    selectedBranchId = '',
    selectedBatchId = '',
    role = ''
  } = useSelector(
    (state: RootState) => ({
      institutes: state.coachingCenter.institutes,
      branches: state.coachingCenter.branches,
      admin: state.coachingCenter.admin,
      batches: state.coachingCenter.batches,
      isLoading: state.coachingCenter.isLoading,
      selectedCoachingCentreId: state.coachingCenter?.admin?.coachingCentreId,
      selectedBranchId: state.coachingCenter?.admin?.branchId,
      selectedBatchId: state.coachingCenter?.admin?.batchId,
      role: state.user.userInfo?.role
    }),
    shallowEqual
  )
  const history = useHistory()
  const [deleteUserId, setDeleteUserId] = useState('')
  const [ids, setIds] = useState(initialState)

  const {
    adminList,
    totalCount,
    page = 1,
    totalPages = 1,
    coachingCentreId,
    branchId,
    batchId
  } = admin || {}

  const {
    menu: {
      admin: { totalNoOfSuperAdmin, superAdminList, addSuperAdmin }
    }
  } = strings
  const dispatch = useDispatch()
  const institutesDropdown = getInstituteDropdown(institutes)
  const branchDropdown = getBranchDropDown(branches)
  const batchDropdown = getBatchDropdown(batches)
  const selectedInstitute = getSelectedInstitute(
    institutes,
    selectedCoachingCentreId
  )
  const selectedBranch = getSelectedBranch(branches, selectedBranchId)
  const selectedBatch = getSelectedBatch(batches, selectedBatchId)

  useEffect(() => {
    dispatch(getInstitutes())
    dispatch(getAdminList({ type: AdminType.SUPERADMIN }))

    return () => {
      dispatch(resetInstitute())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper justifyContent="space-between" hasBorder>
        <SectionTitle title={superAdminList} />
        <Button
          variant="outline-secondary"
          onClick={() =>
            history.push({
              pathname: ROUTES.NEW_USER,
              state: { userType: AdminType.SUPERADMIN }
            })
          }
        >
          {addSuperAdmin}
        </Button>
      </FlexWrapper>
      <FormBackWrapper>
        <UserFilterSection
          role={role}
          institueList={institutesDropdown}
          batchList={batchDropdown}
          branchList={branchDropdown}
          instituteValue={selectedInstitute}
          branchValue={selectedBranch}
          batchValue={selectedBatch}
          handleBatchSelect={(batch: any) => {
            const ids = batch.map((d: DropdownListProps) => d.id)
            dispatch(
              getAdminList({
                type: AdminType.SUPERADMIN,
                pageNo: 1,
                coachingCentreId,
                branchId,
                batchId: `${ids}`
              })
            )
          }}
          handleBranchSelect={(branch: any) => {
            const idss = branch.map((d: DropdownListProps) => d.id)
            dispatch(
              getBatches({
                coachingCentreId: ids.ins,
                branchId: `${idss}`,
                type: AdminType.SUPERADMIN
              })
            )
          }}
          handleinstituteSelect={(institue) => {
            setIds({
              ...ids,
              ins: institue?.id
            })
            dispatch(
              getBranches({
                coachingCentreId: institue?.id,
                type: AdminType.SUPERADMIN
              })
            )
          }
          }
        />
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div>
              <TableWrapper>
                <FlexWrapper justifyContent="end" noPadding>
                  <DisplayAdminCount>
                    {`${totalNoOfSuperAdmin}${totalCount}`}
                  </DisplayAdminCount>
                </FlexWrapper>
                <Table size="sm" responsive="sm">
                  <TableHeader>
                    <TableRow>
                      {tableHeader?.map((header, index) => (
                        <th key={`completed-session-header-${index}`}>
                          {header}
                        </th>
                      ))}
                    </TableRow>
                  </TableHeader>
                  <tbody>
                    {adminList?.map((admin: Admin, index) => (
                      <TableRow key={`admin-${index}`}>
                        <td>{admin?.firstName}</td>
                        <td>{admin?.lastName}</td>
                        <td>{admin?.mobileNumber}</td>
                        <td>{admin?.email}</td>
                        <td>{admin?.status}</td>
                        <td>
                          <UserAction
                            handleUserDetail={() => {
                              dispatch(selectAdmin(admin))
                              history.push(ROUTES.USER_DETAIL)
                            }}
                            handleNewUserSelect={() => {
                              dispatch(selectAdmin(admin))
                              history.push({
                                pathname: ROUTES.NEW_USER,
                                state: {
                                  userType: AdminType.SUPERADMIN,
                                  isEdit: true
                                }
                              })
                            }}
                            handleDelete={() => setDeleteUserId(admin.id)}
                          />
                        </td>
                      </TableRow>
                    ))}
                  </tbody>
                </Table>
                <TableFooter
                  currentPage={page}
                  totalPages={totalPages}
                  handleNext={() =>
                    dispatch(
                      getAdminList({
                        type: AdminType.SUPERADMIN,
                        pageNo: page + 1,
                        coachingCentreId,
                        branchId,
                        batchId
                      })
                    )
                  }
                  handlePrevious={() =>
                    dispatch(
                      getAdminList({
                        type: AdminType.SUPERADMIN,
                        pageNo: page - 1,
                        coachingCentreId,
                        branchId,
                        batchId
                      })
                    )
                  }
                />
              </TableWrapper>

            </div>
          </>
        )}
      </FormBackWrapper>
      {deleteUserId && (
        <Modal
          handleCancel={() => {
            setDeleteUserId('')
          }}
          handleSubmit={() => {
            dispatch(
              deleteUserDetail({ id: deleteUserId, type: AdminType.SUPERADMIN })
            )
            setDeleteUserId('')
          }}
          title={strings.modal.deleteRecord}
        />
      )}
    </PageWrapper>
  )
}

export default SuperAdmin
